var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "contact-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.$route.query.needHelp ? _c('div', {
    staticClass: "d-flex text-center align-items-center top-div"
  }, [_c('router-link', {
    attrs: {
      "button": "",
      "to": `/need-help/${_vm.$route.query.orderNumber}`
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1), _c('h5', [_c('b', [_vm._v(_vm._s(_vm.$route.query.needHelp))])])], 1) : _c('h3', {
    staticClass: "contactHeading font-weight-bold pt-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("contactUs.title")) + " ")])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row section-b-space"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-12 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "contact-right"
  }, [_c('ul', {}, [_c('li', [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-4 contact-icon"
  }, [_c('img', {
    attrs: {
      "src": "img/contact/phone.png",
      "alt": "Phone icon"
    }
  }), _c('h6', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("contactUs.title")) + " ")])]), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-8"
  }, [_c('p', {
    staticClass: "contact-text"
  }, [_vm._v(_vm._s(_vm.storePhone))])])])]), _c('li', [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-4 contact-icon"
  }, [_c('img', {
    attrs: {
      "src": "img/contact/email.png",
      "alt": "Email icon"
    }
  }), _c('h6', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("contactUs.email")) + " ")])]), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-8"
  }, [_c('p', {
    staticClass: "contact-text"
  }, [_vm._v(_vm._s(_vm.storeEmail))])])])]), _c('li', [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-4 contact-icon"
  }, [_c('b-icon', {
    staticStyle: {
      "color": "#ff5044"
    },
    attrs: {
      "icon": "house-door",
      "scale": "1.4"
    }
  }), _c('h6', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("contactUs.address")) + " ")])], 1), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-8"
  }, [_c('p', {
    staticClass: "contact-text"
  }, [_vm._v(" " + _vm._s(_vm.storeAddress) + " ")])])])])])])]), _c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-12"
  }, [_c('GmapMap', {
    staticStyle: {
      "width": "440px",
      "height": "300px"
    },
    attrs: {
      "center": _vm.storePosition,
      "zoom": 7,
      "map-type-id": "terrain"
    }
  }, [_c('GmapMarker', {
    attrs: {
      "label": "★",
      "draggable": true,
      "position": _vm.storePosition
    }
  })], 1)], 1)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }